import { Box, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
	root: {
		height: '100vh',
		width: '100%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},

	animation: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
}));

const SplashScreen = () => {
	const classes = useStyles();

	return (
		<Box className={classes.root}>
			<Box position="relative">
				<Box className={classes.animation}>
					<Box>
						<svg width="120" height="120" viewBox="0 0 50 90" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M49.9874 1.89465e-06H27.766C27.6428 8.37213 26.8189 20.6979 31.1575 24.5636C33.843 26.9557 46.0054 27.7957 56 28.2441V6.01263C56 2.70542 53.2944 1.89465e-06 49.9874 1.89465e-06ZM26.1182 1.89465e-06H6.01261C2.70556 1.89465e-06 0 2.70542 0 6.01263V49.9874C0 53.2946 2.70556 56 6.01261 56H49.9874C53.2944 56 56 53.2946 56 49.9874V29.5968C49.266 29.5375 41.8023 29.751 39.8721 29.9098C37.6645 30.0914 34.9789 30.4796 33.1516 31.3085C27.7272 33.7693 26.6758 49.7698 26.9798 52.2889L25.365 51.3567C26.0243 49.4556 25.8312 37.8605 23.3598 33.9103C20.1578 28.7919 9.02377 28.3558 4.61666 28.4223L5.48716 26.9692C6.89118 27.6364 15.7523 26.7939 17.6211 26.3586C23.0914 25.0852 24.7287 21.8013 25.4484 16.4467C26.0705 11.8206 26.0911 5.45626 26.1182 1.89465e-06Z"
								fill="url(#paint0_linear_20258_79497)"
							/>
							<defs>
								<linearGradient
									id="paint0_linear_20258_79497"
									x1="6.35794"
									y1="53.8823"
									x2="64.4902"
									y2="-2.96533"
									gradientUnits="userSpaceOnUse"
								>
									<stop stop-color="#FFCC2A" />
									<stop offset="1" stop-color="#FFF215" />
								</linearGradient>
							</defs>
						</svg>
					</Box>
					<Box position="absolute" top="-18%" left="-2%">
						<Box className="scaleUp" />
					</Box>
				</Box>
			</Box>
		</Box>
	);
};

export default SplashScreen;
